/* WobbleBag policy pages: builds the "On this page" list and the collapsible
   sections from whatever headings the live Shopify policy content contains. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function slugify(text, index) {
    var slug = text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
    return 'policy-' + (slug || 'section') + '-' + index;
  }

  function groupSections(body) {
    var level = body.querySelector('h2') ? 'H2' : body.querySelector('h3') ? 'H3' : null;
    if (!level) return [];

    var nodes = Array.prototype.slice.call(body.childNodes);
    var groups = [];
    var current = null;
    var lead = document.createDocumentFragment();

    nodes.forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === level) {
        current = { heading: node, nodes: [] };
        groups.push(current);
      } else if (current) {
        current.nodes.push(node);
      } else {
        lead.appendChild(node);
      }
    });

    body.textContent = '';
    if (lead.childNodes.length) {
      var leadWrap = document.createElement('div');
      leadWrap.className = 'wb-policy-body__lead';
      leadWrap.appendChild(lead);
      body.appendChild(leadWrap);
    }

    return groups.map(function (group, index) {
      var title = (group.heading.textContent || '').replace(/^\s*\d+[.)]\s*/, '').trim();
      var id = group.heading.id || slugify(title, index + 1);

      var block = document.createElement('section');
      block.className = 'wb-policy-section-block';
      block.id = id;

      var heading = document.createElement(level.toLowerCase());
      heading.className = 'wb-policy-section-block__heading';

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'wb-policy-section-block__toggle';
      toggle.appendChild(document.createTextNode(title));
      heading.appendChild(toggle);

      var panel = document.createElement('div');
      panel.className = 'wb-policy-section-block__panel';
      panel.id = id + '-panel';
      group.nodes.forEach(function (node) {
        panel.appendChild(node);
      });

      toggle.setAttribute('aria-controls', panel.id);
      block.appendChild(heading);
      block.appendChild(panel);
      body.appendChild(block);

      return { id: id, title: title, block: block, toggle: toggle, panel: panel };
    });
  }

  function setOpen(section, open) {
    section.block.classList.toggle('is-open', open);
    section.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    section.panel.hidden = !open;
  }

  function applyCollapse(sections, collapse) {
    sections.forEach(function (section, index) {
      section.block.classList.toggle('is-collapsible', collapse);
      if (collapse) {
        setOpen(section, index === 0);
      } else {
        section.block.classList.remove('is-open');
        section.toggle.removeAttribute('aria-expanded');
        section.panel.hidden = false;
      }
    });
  }

  function findSection(sections, element) {
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].toggle === element) return sections[i];
    }
    return null;
  }

  function buildToc(toc, sections) {
    var list = toc.querySelector('[data-policy-toc-list]');
    if (!list) return [];

    var links = sections.map(function (section) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.className = 'wb-policy-toc__link';
      link.href = '#' + section.id;
      link.textContent = section.title;
      item.appendChild(link);
      list.appendChild(item);
      return link;
    });

    toc.removeAttribute('hidden');
    return links;
  }

  function watchActive(sections, links) {
    if (!('IntersectionObserver' in window) || !links.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.id;
          links.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
          });
        });
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );

    sections.forEach(function (section) {
      observer.observe(section.block);
    });
  }

  function init(root) {
    var body = root.querySelector('[data-policy-body]');
    if (!body || body.dataset.policyReady === 'true') return;
    body.dataset.policyReady = 'true';

    var sections = groupSections(body);
    var toc = root.querySelector('[data-policy-toc]');

    if (!sections.length) {
      if (toc) toc.remove();
      return;
    }

    var collapseMobile = body.dataset.collapseMobile === 'true';
    var collapseDesktop = body.dataset.collapseDesktop === 'true';
    var mq = window.matchMedia(MOBILE);

    var sync = function () {
      applyCollapse(sections, mq.matches ? collapseMobile : collapseDesktop);
      if (toc) toc.open = !mq.matches;
    };

    sync();
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }

    body.addEventListener('click', function (event) {
      var toggle = event.target.closest('.wb-policy-section-block__toggle');
      if (!toggle || !toggle.hasAttribute('aria-expanded')) return;
      var section = findSection(sections, toggle);
      if (section) setOpen(section, toggle.getAttribute('aria-expanded') !== 'true');
    });

    var links = toc ? buildToc(toc, sections) : [];

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();

        var section = findSection(sections, target.querySelector('.wb-policy-section-block__toggle'));
        if (section && section.toggle.getAttribute('aria-expanded') === 'false') {
          setOpen(section, true);
        }

        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
        history.replaceState(null, '', link.getAttribute('href'));
      });
    });

    watchActive(sections, links);
  }

  function initAll() {
    document.querySelectorAll('.wb-policy').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.wb-policy');
    if (root) init(root);
  });
})();
